// bao migrate skip
import "./../../bindings/foreach-selection";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import BaseViewModel from "./../../factories/base-view-model";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TranslateDialogViewModel from "./../../factories/translate-dialog";
import Explorer from "./../explorer";
class ExplorerFilterDialogViewModel extends BaseViewModel {
    Explorer: Explorer;
    Dialog: BaoDialogViewModel;
    DialogViewModel;
    DialogResult: KnockoutObservable<any>;
    AllMandatorsMessage;
    constructor(tabPage, parent) {
        super(tabPage);
        this.Explorer = parent;
        this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.Dialog.Width("750px");
        this.Dialog.Buttons([{
                Title: Bao.Session.GetMessage("msgOk"),
                Click: () => {
                    if (this.ValidateDialog()) {
                        this.SaveFilter().then(() => {
                            this.DialogResult("ok");
                            this.Close();
                        });
                    }
                }, Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { }
            }, {
                Title: Bao.Session.GetMessage("msgDeleteCaption"),
                Click: () => {
                    this.DeleteFilter();
                }, Enabled: ko.observable(true),
                IsDefault: ko.observable(false),
                Focus: () => { }
            }, {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: () => {
                    this.Close();
                }, Enabled: ko.observable(true),
                IsDefault: ko.observable(false),
                Focus: () => { }
            }]);
        this.DialogViewModel = {};
        this.DialogViewModel.Bao = Bao;
        this.AllMandatorsMessage = Bao.Session.GetMessage("AllMandators");
        // hack: when message is loaded, check again if the captions are set and loaded
        this.AllMandatorsMessage.$deferred.done(() => {
            if (this.DialogViewModel && typeof this.DialogViewModel.AllMandators === "function") {
                this.SetAllMandatorCaption(this.DialogViewModel.AllMandators());
            }
        });
        ;
        this.DialogViewModel.DirtyFlag = ko.dirtyFlag();
        this.DialogResult = ko.observable();
        this.DialogViewModel.TabPage = tabPage;
        this.DialogViewModel.TotalRows = ko.observable();
        this.DialogViewModel.PageIndex = ko.observable(0);
        this.DialogViewModel.PageSize = ko.observable(20);
        this.DialogViewModel.ExplorerFilterDefinitionCollection = ko.observableArray();
        this.DialogViewModel.SelectedExplorerFilterDefinitionRow = ko.observable();
        this.DialogViewModel.SortingExplorerFilterDefintion = ko.observableArray();
        this.DialogViewModel.ExplorerFilterId = ko.observable();
        this.DialogViewModel.Filter = ko.observable();
        this.DialogViewModel.Filter1 = ko.observable();
        this.DialogViewModel.Filter2 = ko.observable();
        this.DialogViewModel.Filter3 = ko.observable();
        this.DialogViewModel.Filter4 = ko.observable();
        this.DialogViewModel.Filter5 = ko.observable();
        this.DialogViewModel.Filter6 = ko.observable();
        this.DialogViewModel.Filter7 = ko.observable();
        this.DialogViewModel.Filter8 = ko.observable();
        this.DialogViewModel.Filter9 = ko.observable();
        this.DialogViewModel.Filter10 = ko.observable();
        this.DialogViewModel.FilterToolbarButtons = ko.observableArray([]);
        this.DialogViewModel.FilterDefinitionToolbarButtons = ko.observableArray([]);
        this.DialogViewModel.Explorer = this.Explorer;
        this.DialogViewModel.IsDirty = ko.observable(false);
        this.DialogViewModel.ExplorerFilterDefinitionTemplateName = ko.observable();
        this.DialogViewModel.ExplorerFilterDefinitionDataSource = ko.observable();
        this.DialogViewModel.SelectedExplorerFilterDefinitionId = ko.observable();
        this.DialogViewModel.PreviousExplorerFilterId = ko.observable();
        this.DialogViewModel.PreviousFilter = ko.observable();
        this.DialogViewModel.SelectedExplorerFilterTypeId = ko.observable();
        this.DialogViewModel.SelectedExplorerFilterType = ko.observable();
        this.DialogViewModel.AllMandators = ko.observable(false);
        this.DialogViewModel.MandatorName = ko.observable();
        this.DialogViewModel.MandatorCaption = ko.observable();
        this.DialogViewModel.AllMandators.subscribe((newValue) => {
            this.SetAllMandatorCaption(newValue);
        });
        this.subscribe(this.DialogViewModel.SelectedExplorerFilterTypeId, (newValue) => {
            if (newValue != null) {
                this.AddExplorerFilterDefinition();
            }
        });
        this.subscribe(this.DialogViewModel.FilterToolbarButtons, () => {
            this.DialogViewModel.ToggleFilterToolbarButtons();
        });
        this.subscribe(this.DialogViewModel.FilterDefinitionToolbarButtons, () => {
            this.DialogViewModel.ToggleFilterDefinitionToolbarButtons();
        });
        this.subscribe(this.DialogViewModel.SelectedExplorerFilterDefinitionRow, (item) => {
            if (item != null) {
                this.LoadExplorerFilterDefinition((<any>item).ExplorerFilterDefinitionId);
            }
            this.DialogViewModel.ToggleFilterDefinitionToolbarButtons();
        });
        this.subscribe(this.DialogViewModel.PreviousExplorerFilterId, () => {
            this.DialogViewModel.PreviousFilter(this.DialogViewModel.Filter());
        });
        this.DialogViewModel.Filter.subscribe(() => {
            this.DialogViewModel["Filter" + Bao.Session.Language.LanguageIndex()](this.DialogViewModel.Filter());
        });
        this.DialogViewModel.FilterComputed = ko.computed(() => {
            if (this.DialogViewModel != undefined) {
                this.DialogViewModel.Filter1();
                this.DialogViewModel.Filter2();
                this.DialogViewModel.Filter3();
                this.DialogViewModel.Filter4();
                this.DialogViewModel.Filter5();
                this.DialogViewModel.Filter6();
                this.DialogViewModel.Filter7();
                this.DialogViewModel.Filter8();
                this.DialogViewModel.Filter9();
                this.DialogViewModel.Filter10();
                this.DialogViewModel.Filter(this.DialogViewModel["Filter" + Bao.Session.Language.LanguageIndex()]());
            }
        });
        this.DialogViewModel.Translate = () => {
            let translateDialog = new TranslateDialogViewModel(this.DialogViewModel.Filter1, this.DialogViewModel.Filter2, this.DialogViewModel.Filter3, this.DialogViewModel.Filter4, this.DialogViewModel.Filter5);
            translateDialog.Open().then(() => {
            });
        };
        this.DialogViewModel.SearchExplorerFilterType = () => {
        };
        this.DialogViewModel.RefreshGrid = () => {
            this.Dialog.IsLoading(true);
            return Bao.post("ExplorerFilter/GetExplorerFilterDefinitionCollection", JSON.stringify({
                explorerFilterId: this.DialogViewModel.ExplorerFilterId(),
                pageIndex: this.DialogViewModel.PageIndex(),
                pageSize: this.DialogViewModel.PageSize(),
                sorting: this.DialogViewModel.SortingExplorerFilterDefintion(),
                sessionTabId: tabPage.SessionTabId
            }), (searchResult) => {
                this.Dialog.IsLoading(false);
                this.DialogViewModel.SelectedExplorerFilterDefinitionRow(null);
                this.DialogViewModel.TotalRows(0);
                this.DialogViewModel.ExplorerFilterDefinitionCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    this.DialogViewModel.ExplorerFilterDefinitionCollection(searchResult.Models);
                    this.DialogViewModel.TotalRows(searchResult.TotalRows);
                }
            });
        };
        this.DialogViewModel.ToggleFilterToolbarButtons = () => {
            ko.utils.arrayForEach(this.DialogViewModel.FilterToolbarButtons(), (button) => {
                switch ((<any>button).ActionKey()) {
                    case "ExplorerFilterEdit":
                    case "ExplorerFilterDelete":
                        (<any>button).Enabled(!(this.DialogViewModel.ExplorerFilterId() == null));
                        break;
                }
            });
        };
        this.DialogViewModel.ToggleFilterDefinitionToolbarButtons = () => {
            ko.utils.arrayForEach(this.DialogViewModel.FilterDefinitionToolbarButtons(), (button) => {
                switch ((<any>button).ActionKey()) {
                    case "actionFilterDefinitionRemove":
                        (<any>button).Enabled(this.DialogViewModel.SelectedExplorerFilterDefinitionRow() != null);
                        break;
                }
            });
        };
        this.Dialog.CloseButtonClicked = () => {
            if (this.DialogViewModel.DirtyFlag()) {
                let questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
                questionDialog.DialogResult.subscribe((result) => {
                    if (result === true) {
                        if (this.ValidateDialog()) {
                            this.SaveFilter().then(() => {
                                this.Close();
                            });
                        }
                    }
                    else if (result === false) {
                        this.Close();
                    }
                    else {
                    }
                });
            }
            else {
                this.Close();
            }
        };
        this.DialogViewModel.toolbarClick = (action) => {
            switch (action.ActionKey()) {
                case "actionFilterDefinitionAdd":
                    this.DialogViewModel.SearchExplorerFilterType();
                    break;
                case "actionFilterDefinitionRemove":
                    this.RemoveExplorerFilterDefinition();
                    break;
            }
        };
    }
    /**
     * Checks if the checkbox is set and set the correct caption for it
     * @param allMandatorChecked true if the checkbox is checked - otherwise false
     */
    private SetAllMandatorCaption(allMandatorChecked: any) {
        if (allMandatorChecked) {
            this.DialogViewModel.MandatorId(null);
            this.DialogViewModel.MandatorName("");
            this.DialogViewModel.MandatorCaption(this.AllMandatorsMessage());
        }
        else {
            this.DialogViewModel.MandatorCaption("");
        }
    }
    ValidateDialog() {
        let isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.DialogViewModel.Filter())) {
            isComplete = false;
        }
        if (!this.DialogViewModel.AllMandators() && Bao.Utils.String.IsNullOrEmpty(this.DialogViewModel.MandatorId())) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    ;
    AddExplorerFilterDefinition() {
        this.Dialog.IsLoading(true);
        this.DialogViewModel.DirtyFlag(true);
        return Bao.post("ExplorerFilter/AddExplorerFilterDefinition", JSON.stringify({
            explorerFilterId: this.DialogViewModel.ExplorerFilterId(),
            explorerFilterTypeId: this.DialogViewModel.SelectedExplorerFilterTypeId(),
            sessionTabId: this.TabPage.SessionTabId
        }), (value) => {
            this.DialogViewModel.RefreshGrid();
        });
    }
    ;
    RemoveExplorerFilterDefinition() {
        this.Dialog.IsLoading(true);
        this.DialogViewModel.DirtyFlag(true);
        return Bao.post("ExplorerFilter/RemoveExplorerFilterDefinition", JSON.stringify({
            explorerFilterId: this.DialogViewModel.ExplorerFilterId(),
            explorerFilterDefinitionId: this.DialogViewModel.SelectedExplorerFilterDefinitionRow().ExplorerFilterDefinitionId,
            sessionTabId: this.TabPage.SessionTabId
        }), (value) => {
            this.DialogViewModel.RefreshGrid();
        });
    }
    ;
    ResetSession() {
        this.Dialog.IsLoading(true);
        return Bao.post("ExplorerFilter/ResetExplorerFilter", JSON.stringify({
            sessionTabId: this.TabPage.SessionTabId,
            explorerFilterId: this.DialogViewModel.ExplorerFilterId()
        }), () => {
            this.Dialog.IsLoading(false);
        });
    }
    ;
    MinimizeEntity() {
        return {
            Filter: this.DialogViewModel.Filter(),
            Filter1: this.DialogViewModel.Filter1(),
            Filter2: this.DialogViewModel.Filter2(),
            Filter3: this.DialogViewModel.Filter3(),
            Filter4: this.DialogViewModel.Filter4(),
            Filter5: this.DialogViewModel.Filter5(),
            Filter6: this.DialogViewModel.Filter6(),
            Filter7: this.DialogViewModel.Filter7(),
            Filter8: this.DialogViewModel.Filter8(),
            Filter9: this.DialogViewModel.Filter9(),
            Filter10: this.DialogViewModel.Filter10(),
            ExplorerFilterId: this.DialogViewModel.ExplorerFilterId(),
            ExplorerTypeId: this.DialogViewModel.ExplorerTypeId(),
            MandatorId: this.DialogViewModel.MandatorId(),
            IsNew: this.DialogViewModel.IsNew()
        };
    }
    ;
    SaveFilter() {
        return Bao.post("ExplorerFilter/SaveExplorerFilter", JSON.stringify({
            explorerFilterModel: this.MinimizeEntity(),
            sessionTabId: this.TabPage.SessionTabId
        }), () => {
            this.DialogViewModel.DirtyFlag(false);
        });
    }
    ;
    LoadExplorerFilterDefinition(explorerFilterDefinitionId) {
        this.Dialog.IsLoading(true);
        this.DialogViewModel.ExplorerFilterDefinitionTemplateName(null);
        Bao.Templates["ExplorerFilterDefinition_" + explorerFilterDefinitionId] = null;
        return Bao.post("ExplorerFilter/GetExplorerFilterDefinitionDataSource", JSON.stringify({
            explorerFilterDefinitionId: explorerFilterDefinitionId,
            explorerFilterId: this.DialogViewModel.ExplorerFilterId(),
            sessionTabId: this.TabPage.SessionTabId
        })).then((result) => {
            this.DialogViewModel.SelectedExplorerFilterDefinitionId(explorerFilterDefinitionId);
            this.DialogViewModel.ExplorerFilterDefinitionDataSource(result.Model);
            Bao.Templates["ExplorerFilterDefinition_" + explorerFilterDefinitionId] = result.Html;
            this.DialogViewModel.ExplorerFilterDefinitionTemplateName("ExplorerFilterDefinition_" + explorerFilterDefinitionId);
            this.Dialog.IsLoading(false);
        });
    }
    ;
    Close() {
        return this.ResetSession().then(() => {
            this.DestroyObject();
            this.Dialog.Close();
        });
    }
    ;
    DeleteFilter() {
        let questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("ExplorerDeleteFilter"), "yesno");
        this.subscribe(questionDialog.DialogResult, (result) => {
            if (result === true) {
                Bao.post("ExplorerFilter/DeleteExplorerFilter", JSON.stringify({
                    explorerFilterId: this.DialogViewModel.ExplorerFilterId()
                }), () => {
                    this.Close().then(() => {
                        this.DialogResult("ok");
                    });
                });
            }
        });
    }
    ;
    Show(filterId) {
        this.Dialog.IsLoading(true);
        this.DialogViewModel.ExplorerFilterId(filterId);
        $.when(Bao.post("ExplorerFilter/ExplorerFilterDialog", JSON.stringify({
            explorerFilterId: filterId,
            sessionTabId: this.TabPage.SessionTabId
        })), this.Refresh()).then((view, model) => {
            ko.map.fromJS(model[0], this.DialogViewModel, this.DialogViewModel.DirtyFlag);
            this.DialogViewModel.RefreshGrid(false);
            this.Dialog.ViewModel(this.DialogViewModel);
            this.Dialog.Template(view[0]);
            this.Dialog.Open();
            this.Dialog.IsLoading(false);
            this.TabPage.IsLoading(false);
        });
    }
    ;
    Refresh() {
        return Bao.post("ExplorerFilter/ExplorerFilterModel", JSON.stringify({
            explorerFilterId: this.DialogViewModel.ExplorerFilterId(),
            sessionTabId: this.TabPage.SessionTabId,
            explorerTypeId: this.Explorer.ExplorerTypeId()
        }));
    }
    ;
}
export default ExplorerFilterDialogViewModel;